import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=047257ee&scoped=true&"
import script from "./tenant.vue?vue&type=script&lang=js&"
export * from "./tenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047257ee",
  null
  
)

export default component.exports